import {
  ABTesting,
  ABTestingScenarioIsUnset,
  getABTestingObject,
  setABTestingPricingScenario,
  setABTestingScenarioDefault,
  setABTestingStockShortageScenario
} from './frameworks_drivers/redux/reducers/abTest/abTesting';
import { ABTestingScenarios } from './frameworks_drivers/redux/reducers/abTest/TestingScenarios';

const initABTesting = (): ABTesting => {
  const queryParams = new URLSearchParams(window.location.search);

  decideABTestingScenarios(queryParams);

  return getABTestingObject();
};

const decideABTestingScenarios = (queryParams: URLSearchParams) => {
  const defaultScenarioEnforcedParam = queryParams.get('no_ab');

  // !! Only set ab testing scenario if its unset in local persistent storage.
  if (ABTestingScenarioIsUnset()) {
    if (defaultScenarioEnforcedParam && defaultScenarioEnforcedParam === 'true') {
      setABTestingScenarioDefault();
    } else {
      const abPricingScenario =
        Math.random() > 0.5
          ? ABTestingScenarios.Pricing.ScenarioB
          : ABTestingScenarios.Pricing.Default; // 50/50 split

      const abStockShortageScenario =
        Math.random() > 0.5
          ? ABTestingScenarios.StockShortage.A
          : ABTestingScenarios.StockShortage.B; // 50/50 split

      setABTestingPricingScenario(abPricingScenario);
      setABTestingStockShortageScenario(abStockShortageScenario);
    }
  }
};

export default initABTesting;
